const StatusDepositPaid: React.FunctionComponent = function () {
  return <div>Paid</div>;
};

export default StatusDepositPaid;
